/**
 * @fileoverview History API to do pushstate.
 */

var $ = require('jquery');

var historyApi = {
  onPopState: function(callback, opt_context) {
    var x = function() {
      if (opt_context) {
        callback.apply(opt_context, arguments);
      } else {
        callback.apply(this, arguments);
      }
    };
    $(window).bind('popstate', x);
  },

  pushQueryParam: function(object) {
    var loc = window.location;
    var url = loc.protocol + '//' + loc.host + loc.pathname;
    var first = true;
    if (url.indexOf('?') === -1) {
      url += '?';
    }
    $.each(object, function(key, value) {
      var str = '';
      if (!first) {
        str = '&';
      }
      url += str + key + '=' + value;
      first = false;
    });
    history.pushState(null, null, url);
  },

  getQueryObject: function() {
    var loc = window.location;
    var sections = loc.href.split('?');
    if (sections.length < 2) {
      return {};
    }

    var queryObject = {};
    $.each(sections[1].split('&'), function(idx, key) {
      var parts = key.split('=');
      if (parts.length > 1) {
        queryObject[parts[0]] = parts[1];
      } else {
        queryObject[parts[0]] = undefined;
      }
    });

    return queryObject;
  },

  isAvailable: !!window.history && typeof history.pushState !== 'undefined'
};

module.exports = historyApi;
